
import firebaseConfig from './firebaseConfig';

export default firebaseConfig.URLs;
